exports.list = {
    path: '/laporan_piutang_lain',
    name: 'laporan_piutang_lain', 
      meta: {
        authRequired: true,
      },
    component: () => import("@/views/main/laporan_piutang_lain/List.vue"),
  }
  